export default "/images/vendor/pdfjs-dist/web/shadow.png?4d046de3539f9ccc9ce07d3d1b786846";